import React, { Component } from "react";

import { Typeahead } from "../../form-inputs/typeahead";

const options = [
    {
        value: "1",
        text: "One",
    },
    {
        value: "2",
        text: "Two",
    },
    {
        value: "3",
        text: "Three",
    },
];

class TypeaheadExamples extends Component {
    constructor(props) {
        super(props);
        this.state = {
            creatableTypeahead: "",
            creatableMultiTypeahead: "",
            numbersTypeahead: {
                value: "1",
                text: "One",
            },
            multiTypeahead: [
                {
                    value: "1",
                    text: "One",
                },
            ],
            simpleNumbersTypeahead: "1",
            simpleMultiTypeahead: ["1"],
        };
    }

    updateField = (name, value) => {
        /*this.setState({
            [name]: value
        });*/
    };

    render() {
        return (
            <div>
                <h3>Full object</h3>
                <Typeahead name="numbersTypeahead" label="Numbers" options={options} defaultValue={this.state.numbersTypeahead} updateOnChange={this.updateField} />
                <Typeahead name="multiTypeahead" label="Multi" options={options} defaultValue={this.state.multiTypeahead} updateOnChange={this.updateField} multiple={true} />
                <h3>Creatable</h3>
                <Typeahead name="creatableTypeahead" label="Creatable" creatable={true} options={options} defaultValue={this.state.creatableTypeahead} updateOnChange={this.updateField} />
                <Typeahead
                    name="creatableMultiTypeahead"
                    label="Creatable (Multi)"
                    creatable={true}
                    options={options}
                    defaultValue={this.state.creatableMultiTypeahead}
                    multiple={true}
                    updateOnChange={this.updateField}
                />
            </div>
        );
    }
}

export default TypeaheadExamples;
